import { render, staticRenderFns } from "./EModalDuplicarAula.vue?vue&type=template&id=ebca5aa8&"
import script from "./EModalDuplicarAula.vue?vue&type=script&lang=js&"
export * from "./EModalDuplicarAula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports